import React, { useState, useRef, useCallback, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { useSecureAuth } from '../../contexts/SecureAuthContext';
import SupportFAB from './SupportFAB';
import SupportPanel from './SupportPanel';

const SupportWidget: React.FC = () => {
  const { user } = useSecureAuth();
  const location = useLocation();
  const ticketLink = new URLSearchParams(location.search).get('supportTicket');
  const linkedTicket = ticketLink && /^SUP-[A-F0-9]{20}$/.test(ticketLink) ? ticketLink : null;
  const [isOpen, setIsOpen] = useState(false);
  const fabRef = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    if (linkedTicket && location.pathname !== '/master/dashboard') setIsOpen(true);
  }, [linkedTicket, location.pathname]);

  const handleOpen = useCallback(() => setIsOpen(true), []);
  const handleClose = useCallback(() => setIsOpen(false), []);

  return (
    <>
      <SupportFAB ref={fabRef} onClick={handleOpen} isOpen={isOpen} />
      <AnimatePresence>
        {isOpen && <SupportPanel key={`${user?.uid || 'signed-out'}:${linkedTicket || ''}`} onClose={handleClose} fabRef={fabRef} initialTicketId={linkedTicket} />}
      </AnimatePresence>
    </>
  );
};

export default SupportWidget;
